import { BiSolidSun, BiSolidMoon } from "react-icons/bi";
import { HiMenuAlt3, HiMenuAlt1 } from "react-icons/hi";
import { FaShoppingCart, FaUserCircle } from "react-icons/fa"; // Import the profile icon
import ResponsiveMenu from "./ResponsiveMenu";
import { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { getUser } from "../Utility/getUser"; // Import the getUser function
import { Navlinks } from "../constants/Navlinks"; // Import Navlinks from constants

const Navbar = ({ theme, setTheme, cartCount }) => {
  const [showMenu, setShowMenu] = useState(false);
  const [user, setUser] = useState(null);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  useEffect(() => {
    const loggedInUser = getUser();
    setUser(loggedInUser);
  }, []);

  return (
    <div className="relative z-20 w-full bg-transparent dark:bg-transparent dark:text-white duration-300">
      <div className="container py-2 md:py-0">
        <div className="flex justify-between items-center">
          <div>
            <span className="text-3xl font-bold font-serif text-red-600">BuchMe</span>
          </div>
          <nav className="hidden md:block">
            <ul className="flex items-center gap-8">
              {Navlinks.map(({ id, name, link }) => (
                <li key={id} className="py-4">
                  <a
                    href={link}
                    className="text-lg font-medium hover:text-red-500 py-2 hover:border-b-2 hover:border-red-500 transition-colors duration-500"
                  >
                    {name}
                  </a>
                </li>
              ))}

              {/* DarkMode feature implement */}
              {theme === "dark" ? (
                <BiSolidSun
                  onClick={() => setTheme("light")}
                  className="text-2xl hover:text-red-500"
                />
              ) : (
                <BiSolidMoon
                  onClick={() => setTheme("dark")}
                  className="text-2xl hover:text-red-500"
                />
              )}
            </ul>
          </nav>
          {/* Mobile view */}
          <div className="flex items-center gap-4 md:hidden">
            {/* dark mode */}
            {theme === "dark" ? (
              <BiSolidSun
                onClick={() => setTheme("light")}
                className="text-2xl hover:text-red-600"
              />
            ) : (
              <BiSolidMoon
                onClick={() => setTheme("dark")}
                className="text-2xl hover:text-red-600"
              />
            )}

            {/* Mobile Hamburger icon */}
            {showMenu ? (
              <HiMenuAlt1
                onClick={toggleMenu}
                className="cursor-pointer transition-all hover:text-red-600"
                size={30}
              />
            ) : (
              <HiMenuAlt3
                onClick={toggleMenu}
                className="cursor-pointer transition-all hover:text-red-600"
                size={30}
              />
            )}
          </div>
        </div>
      </div>
      <ResponsiveMenu showMenu={showMenu} />
    </div>
  );
};

Navbar.propTypes = {
  theme: PropTypes.string.isRequired,
  setTheme: PropTypes.func.isRequired,
  cartCount: PropTypes.number.isRequired,
};

export default Navbar;
